import "./inputAcervo.css";

function InputAcervo({
  boxSizing,
  padding,
  marginRight,
  width,
  placeholder,
  value,
  onChange,
  disabled = false,
}) {
  // Função para garantir que apenas números sejam permitidos e que não ultrapasse 999
  function handleChange(e) {
    const newValue = e.target.value;
    // Verifica se o valor contém apenas números e é menor ou igual a 999
    if (/^\d*$/.test(newValue) && parseInt(newValue) <= 99999) {
      onChange(newValue); // Chama onChange apenas se for um número e <= 999
    }
  }

  // Funções de incremento e decremento com validação de limite
  function handleIncrement() {
    if (value < 99999) {
      onChange((prevValue) => Math.min(prevValue + 1, 99999)); // Incrementa, mas não ultrapassa 999
    }
  }

  function handleDecrement() {
    if (value > 1) {
      onChange((prevValue) => Math.max(prevValue - 1, 1)); // Decrementa, mas não vai abaixo de 1
    }
  }

  return (
    <div style={{ position: "relative", width: width }}>
      <input
        type="text" // Altere para "text" para permitir o controle completo da entrada
        inputMode="numeric" // Exibe o teclado numérico em dispositivos móveis
        min="1"
        style={{
          color: "var(--cor-preto)",
          backgroundColor: "var(--cor-branco)",
          border: "1px solid var(--cor-cinzaMargin)",
          marginTop: 5,
          marginRight: 20,
          fontSize: 20,
          marginRight: marginRight,
          borderRadius: "10px",
          width: "79%",
          height: 45,
          fontFamily: "Roboto",
          padding: padding,
          textAlign: "center",
          boxSizing: boxSizing,
          WebkitAppearance: "textfield", // Remove os botões no WebKit
          MozAppearance: "textfield", // Remove no Firefox
        }}
        disabled={disabled}
        value={value}
        placeholder={placeholder}
        onChange={handleChange} // Chama a função handleChange
      />

      <button
        onClick={handleDecrement} // Chama handleDecrement para decremento
        style={{
          position: "absolute",
          left: "10px",
          top: "55%",
          transform: "translateY(-50%)",
          backgroundColor: "var(--cor-branco)",
          color: "var(--cor-preto)",
          border: "1px solid var(--cor-preto)",
          borderRadius: "50%",
          fontSize: "15px",
          cursor: "pointer",
          width: 20,
          alignItems: "center",
          textAlign: "center",
        }}
        disabled={disabled}
      >
        -
      </button>

      <button
        onClick={handleIncrement} // Chama handleIncrement para incremento
        style={{
          position: "absolute",
          right: "42px",
          top: "55%",
          transform: "translateY(-50%)",
          backgroundColor: "var(--cor-branco)",
          color: "var(--cor-preto)",
          border: "1px solid var(--cor-preto)",
          borderRadius: "50%",
          fontSize: "15px",
          cursor: "pointer",
          width: 20,
          alignItems: "center",
          textAlign: "center",
        }}
        disabled={disabled}
      >
        +
      </button>
    </div>
  );
}

export default InputAcervo;
